module.exports = __webpack_public_path__ + "img/icon_city.3797287f.png";